export default "https://cdn-static.gokick.com/assets/31e0b9f53043906ee01608417204ccf2abfa2ab1/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";